/**
 * @fileoverview Class name utility function combining clsx and tailwind-merge.
 * @module shared/utils/cn
 */

import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names using clsx and merges Tailwind classes intelligently.
 * This utility resolves conflicting Tailwind classes and handles conditional classes.
 *
 * @param inputs - Class names, objects, or arrays to combine
 * @returns Merged and optimized class string
 * @example
 * ```typescript
 * cn("px-2 py-1", condition && "bg-blue-500", { "text-red-500": isError })
 * // Returns: "px-2 py-1 bg-blue-500 text-red-500" (if condition=true, isError=true)
 *
 * cn("px-2", "px-4") // Returns: "px-4" (tailwind-merge resolves conflicts)
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
